import useUser from './useUser';
import { useDispatch } from 'react-redux';
import { fetchAgentStats } from 'store/user/user.actions';
import useAppConfig from 'hooks/redux/useAppConfig';
import useInterval from 'hooks/useInterval';

export default function useStats() {
    const { agentContactStatsByQueue } = useUser();
    const appConfig = useAppConfig();
    const pollTime = appConfig.agentStatsPollTimeSeconds ? appConfig.agentStatsPollTimeSeconds : 60;

    const dispatch = useDispatch();

    useInterval(() => dispatch(fetchAgentStats()), 1000 * pollTime, true);

    return {
        agentContactStatsByQueue,
    };
}
